<template>
  <!--the alert class is added from the input element-->
  <div id="alert" uk-alert>
    <a v-if="data.closeable" class="uk-alert-close" uk-close @click="clickClose"></a>
    <h3 v-if="data.title">
      <span :uk-icon="'icon:' + data.icon + '; ratio: 1.5'" v-if="data.icon" class="uk-margin-small-right"></span>
      {{ data.title }}
    </h3>
    <p>
      <span :uk-icon="'icon:' + data.icon + '; ratio: 1.5'" v-if="data.icon && !data.title" class="uk-margin-medium-right"></span>
      {{ data.body }}
    </p>
    <div v-html="data.html"></div>
  </div>
</template>

<script>
	export default {
		name: "Alert",
		props: ["data"],
      methods: {
		  clickClose: function(){
		    this.$emit('close', true)
          }
      }
	}
</script>

<style lang="less" scoped>


  @import "../../assets/less/palette.less";

  #alert {
    margin: 1em auto;
    width: 90%;
    border-radius: 6px;
  }


  h3 {
    display: flex;
    align-items: baseline;
    justify-content: center;
  }
</style>
